import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@material-ui/core';
import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import AddCircle from '@material-ui/icons/AddCircle';

import { AdminPeopleInvite } from 'Links';

const styles = (theme: Theme) =>
  createStyles({
    inviteButton: {
      borderRadius: 4,
    },
  });

const Header: FC<WithStyles<typeof styles>> = props => {
  const { classes } = props;
  const { t } = useTranslation();

  return (
    <Button
      className={classes.inviteButton}
      variant="contained"
      color="primary"
      startIcon={<AddCircle />}
      component={AdminPeopleInvite}>
      {t('admin:invitePeople')}
    </Button>
  );
};

export default withStyles(styles)(Header);
